document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-footer-cookie-preferences]');
  if (!button) return;

  const banner = window.privacyBanner || window.Shopify?.privacyBanner;
  const preferences = banner?.showPreferences || window.Shopify?.customerPrivacy?.showPreferences;
  if (typeof preferences === 'function') {
    preferences.call(banner || window.Shopify.customerPrivacy);
  } else {
    window.location.href = button.dataset.fallbackUrl;
  }
});

